import {Component, OnDestroy, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Credentials} from "./credentials.interface";
import {AuthenticationService} from "../shared/authentication.service";
import {Router, ActivatedRoute} from "@angular/router";
import {ApiError} from "../shared/api/error.interface";
import {Subscription} from "rxjs/Subscription";

@Component({
    selector : 'login',
    template: require('./login.component.html'),
    styles: [require('./login.component.scss')]
})

export class LoginComponent implements OnInit, OnDestroy {
    protected returnUrl: string;
    public loginForm: FormGroup;
    public invalidCredentials: boolean = false;
    public showHelper: boolean = false;
    private authenticatedSubscription: Subscription;

    constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private route: ActivatedRoute) {}

    ngOnInit() {
        this.showHelper = process.env.ENV === 'development';

        this.loginForm = this.fb.group({
            username : ['', [Validators.required]],
            password:  ['', [Validators.required]]
        });

        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';

        this.authenticatedSubscription = this.auth.isAuthenticated().subscribe((authenticated: boolean) => {
            if (authenticated === true) {
                return this.router.navigate([this.returnUrl]);
            }
        });
    }

    ngOnDestroy() {
        if (this.authenticatedSubscription) {
            this.authenticatedSubscription.unsubscribe();
        }
    }

    login(model: Credentials) {
        this.invalidCredentials = false;

        this.auth.authenticate(model.username, model.password).subscribe(
            () => {
                return this.router.navigate([this.returnUrl]);
            },
            (error: ApiError) => {
                this.invalidCredentials = true;
            }
        );

        return false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/login/login.component.ts